import "./styles.css";
import { FleetInstructionsAlert } from "./fleetAlert";
import { useFreire } from "../../utils/freireContext";
import * as texts from "./locales";

const FleetInstructions = () => {
  const { freire } = useFreire();

  return (
    <div className="fleet-instructions-container">
      <span className="fleet-instructions-title">
        {freire(texts.FLEET_CAMPAIGNS_TITLE)}
      </span>
      <div className="fleet-instructions-description">
        <span>{freire(texts.FLEET_CAMPAIGNS_DESCRIPTION_1)}</span>
        <span>{freire(texts.FLEET_CAMPAIGNS_DESCRIPTION_2)}</span>
      </div>
      <FleetInstructionsAlert />
    </div>
  );
};

export default FleetInstructions;
